import React, { Fragment } from "react";
// import LoaderCSS from "./Loader.module.css";
import LoaderCSS from "./Loader.module.scss";
import { Spinner } from "react-rainbow-components";
import loaderIcon from "../../assets/images/common/page-loader-icon.svg";

const AddVantegaeLoader = () => {
  return (
    <img src={loaderIcon} alt="Loader" />
  );
};
const Loader = () => {
  return (
    <Fragment>
      <div className={LoaderCSS.loader_wrapper}>
        <Spinner size="x-large" type="arc" variant="brand">
          <AddVantegaeLoader />
        </Spinner>
      </div>
      {/* <div className="rainbow-p-vertical_xx-large">
        <div className="rainbow-position_relative rainbow-p-vertical_xx-large">
          <Spinner size="x-large" type="arc" variant="brand">
            <AddVantegaeLoader />
          </Spinner>
        </div>
      </div> */}
    </Fragment>
  );
};

export default Loader;
